import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_ArrowSlider",
  "use": "Lenspire_Icon_ArrowSlider-usage",
  "viewBox": "0 0 30 60",
  "content": "<symbol viewBox=\"0 0 30 60\" id=\"Lenspire_Icon_ArrowSlider\">\n<g>\n\t<path d=\"M29.013,60c-0.259,0-0.517-0.103-0.71-0.306L0,30L28.303,0.306c0.38-0.396,1.004-0.409,1.396-0.025\n\t\tc0.392,0.384,0.402,1.017,0.023,1.414L2.745,30l26.978,28.306c0.379,0.397,0.368,1.03-0.023,1.414\n\t\tC29.507,59.907,29.26,60,29.013,60z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_ArrowSlider.svg
// module id = 561
// module chunks = 0